import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

interface CompanyRow {
  id: string;
  name: string;
  matricule_fiscal: string;
  legal_form: string;
  tax_regime: string;
  onboarded_at: string;
}

export function CompaniesPage() {
  const [companies, setCompanies] = useState<CompanyRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .listCompanies()
      .then((r) => setCompanies(r.companies as CompanyRow[]))
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <div className="space-y-4 max-w-5xl">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-serif text-3xl font-bold mb-1">Dossiers clients</h2>
          <p className="text-taupe text-sm">
            Toutes les entreprises gérées par votre cabinet. Pour en ajouter, lancez l'agent Onboardeur.
          </p>
        </div>
        <Link to="/agents/onboardeur" className="btn-primary">
          + Onboarder un client
        </Link>
      </div>

      {error && <div className="card border border-red-300 bg-red-50 text-red-900 text-sm">{error}</div>}
      {companies === null && !error && <div className="text-taupe text-sm">Chargement…</div>}

      {companies !== null && companies.length === 0 && (
        <div className="card text-center py-12">
          <p className="text-taupe mb-4">Aucun dossier client. Démarrez avec l'Onboardeur.</p>
          <Link to="/agents/onboardeur" className="btn-secondary inline-block">
            Onboarder un nouveau client
          </Link>
        </div>
      )}

      {companies !== null && companies.length > 0 && (
        <div className="card !p-0 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-cream/40 text-xs uppercase tracking-wider text-taupe border-b border-border">
                <th className="px-3 py-2 text-left">Raison sociale</th>
                <th className="px-3 py-2 text-left">Matricule</th>
                <th className="px-3 py-2 text-left">Forme</th>
                <th className="px-3 py-2 text-left">Régime</th>
                <th className="px-3 py-2 text-left">Onboardé</th>
              </tr>
            </thead>
            <tbody>
              {companies.map((c) => (
                <tr key={c.id} className="border-b border-border/50 hover:bg-cream/30">
                  <td className="px-3 py-2 font-medium">{c.name}</td>
                  <td className="px-3 py-2 font-mono text-xs">{c.matricule_fiscal}</td>
                  <td className="px-3 py-2 text-xs">{c.legal_form}</td>
                  <td className="px-3 py-2 text-xs capitalize">{c.tax_regime.replace(/_/g, ' ')}</td>
                  <td className="px-3 py-2 text-xs text-taupe">{formatDate(c.onboarded_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('fr-FR');
  } catch {
    return iso;
  }
}
